module.exports = __webpack_public_path__ + "static/collab-ffd52f6e60e1580dc53fd347eeb0f4e2.svg";